import React from 'react';

function ViewEvent({ user, closeModal }) {
  if (!user) return null;

  const BASE_URL = process.env.REACT_APP_URL;

  // =========================
  // Format Date
  // =========================
  function formatDate(date) {
    if (!date) return 'N/A';

    return new Date(date).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  // =========================
  // Image URL
  // =========================
  const imageUrl = user?.eventBanner
    ? `${BASE_URL}${user.eventBanner}`
    : null;

  return (
    <div
      className="modal fade viewbox edit-box show d-block"
      id="eventModal"
      tabIndex={-1}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">

        <div className="modal-content">

          {/* =========================
              Header
          ========================== */}
          <div className="modal-header">

            <h5 className="modal-title">
              Event Details
            </h5>

            <button
              type="button"
              className="btn-close"
              onClick={closeModal}
              aria-label="Close"
            />

          </div>


          {/* =========================
              Body
          ========================== */}
          <div className="modal-body px-5">

            {/* =========================
                Event Information
            ========================== */}
            <div className="d-box mt-3 pt-1">

              <h3
                className="service-heading"
                style={{ marginBottom: '15px' }}
              >
                Event Information
              </h3>

              <ul className="d-flex list-unstyled flex-wrap justify-content-between">

                {/* Event Name */}
                <li className="w-50 mb-3">
                  <strong>Event Name: </strong>
                  {user?.eventName || 'N/A'}
                </li>


                {/* Venue */}
                <li className="w-50 mb-3">
                  <strong>Venue: </strong>
                  {user?.venue || 'N/A'}
                </li>


                {/* Description */}
                <li className="w-100 mb-3">
                  <strong>Description: </strong>
                  {user?.eventDescription || 'N/A'}
                </li>


                {/* Event Date */}
                <li className="w-50 mb-3">
                  <strong>Event Date: </strong>
                  {formatDate(user?.eventDate)}
                </li>


                {/* Start Time */}
                <li className="w-50 mb-3">
                  <strong>Start Time: </strong>
                  {user?.startTime || 'N/A'}
                </li>


                {/* End Time */}
                <li className="w-50 mb-3">
                  <strong>End Time: </strong>
                  {user?.endTime || 'N/A'}
                </li>


                {/* Total Capacity */}
                <li className="w-50 mb-3">
                  <strong>Total Capacity: </strong>
                  {user?.totalCapacity ?? 'N/A'}
                </li>


                {/* Status */}
                <li className="w-50 mb-3">
                  <strong>Status: </strong>
                  {user?.status || 'N/A'}
                </li>

              </ul>

            </div>


            {/* =========================
                Location
            ========================== */}
            <div className="d-box mt-4 pt-1">

              <h3
                className="service-heading"
                style={{ marginBottom: '15px' }}
              >
                Location
              </h3>

              <ul className="d-flex list-unstyled flex-wrap justify-content-between">

                {/* Address */}
                <li className="w-100 mb-3">
                  <strong>Address: </strong>
                  {user?.address || 'N/A'}
                </li>


                {/* City */}
                <li className="w-50 mb-3">
                  <strong>City: </strong>
                  {user?.city || 'N/A'}
                </li>

              </ul>

            </div>


            {/* =========================
                Terms & Conditions
            ========================== */}
            <div className="d-box mt-4 pt-1">

              <h3
                className="service-heading"
                style={{ marginBottom: '15px' }}
              >
                Terms & Conditions
              </h3>

              <ul className="d-flex list-unstyled flex-wrap">

                <li className="w-100 mb-3">
                  {user?.termsConditions || 'N/A'}
                </li>

              </ul>

            </div>


            {/* =========================
                Event Image
            ========================== */}
            <div className="d-box mt-4 pt-1">

              <h3
                className="service-heading"
                style={{ marginBottom: '15px' }}
              >
                Event Image
              </h3>

              {imageUrl ? (

                <img
                  src={imageUrl}
                  alt={user?.eventName || 'Event'}
                  style={{
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    borderRadius: '8px',
                    border: '1px solid #ccc'
                  }}
                />

              ) : (

                <span>N/A</span>

              )}

            </div>


            {/* =========================
                Created Date
            ========================== */}
            <div className="d-box mt-4 pt-1">

              <ul className="d-flex list-unstyled">

                <li>
                  <strong>
                    Created Date:
                  </strong>{' '}

                  {formatDate(user?.createdAt)}
                </li>

              </ul>

            </div>

          </div>

        </div>

      </div>
    </div>
  );
}

export default ViewEvent;